import { RawButton } from '@/components/Button'
import styles from './ConfirmEmailView.module.css'
import { EmailConfirmationScreen } from '@/features/email-confirmation/components/EmailConfirmationScreen'

export interface ConfirmEmailViewProps {
  pageExpired: boolean
  email: string
  onResendVerificationEmail: () => unknown
  logoPrimary: string
  landingPageImage: string
}

export function ConfirmEmailView({
  pageExpired,
  email,
  onResendVerificationEmail,
  logoPrimary,
  landingPageImage,
}: ConfirmEmailViewProps) {
  return (
    <EmailConfirmationScreen
      logoPrimary={logoPrimary}
      landingPageImage={landingPageImage}
    >
      <div className={styles.title}>
        {!pageExpired ? (
          <>Check your inbox and verify your email address</>
        ) : (
          <>This page has expired</>
        )}
      </div>
      <div className={styles.description}>
        {!pageExpired ? (
          <>
            We've sent a confirmation link to <b>{email}</b>.
          </>
        ) : (
          <>Please log in again.</>
        )}
      </div>
      {!pageExpired && (
        <div className={styles.help}>
          <div className={styles.helpTitle}>Didn't receive the email?</div>
          <p>
            Check your spam folder or{' '}
            <b>
              <RawButton
                className={styles.resendEmail}
                onPress={onResendVerificationEmail}
              >
                send the email again.
              </RawButton>
            </b>
          </p>
        </div>
      )}
    </EmailConfirmationScreen>
  )
}
